import { useEffect, useRef, useState } from 'preact/hooks'
import { getPBProps } from '@content/helpers/src/utils.ts'
import { PbPropsProvider } from '@content/helpers/src/context.tsx'
import useImpressionTracker from '@content/helpers/src/hooks/useImpressionTracker.ts'
import { Collapse } from '@nespresso-design-system/components'
import { isLoggedIn as checkLoginStatus } from '@content/helpers/src/dataLayer'
import styles from './MgmFaq.module.scss'
import { PBProps } from '@components/member-get-member/mgm-faq-v2/types.ts'
import { getTestId } from '@content/helpers/src/utils'

type FaqProps = {
    data: string
}

function Faq({ data }: FaqProps) {
    const pbProps = getPBProps<PBProps>(data)
    const { copywriting, campaign } = pbProps as PBProps
    const containerRef = useRef(null)

    useImpressionTracker(containerRef, campaign)

    const [isLoggedIn, setIsLoggedIn] = useState(false)

    useEffect(() => {
        const interval = setInterval(() => {
            const status = checkLoginStatus()
            setIsLoggedIn(prev => (prev !== status ? status : prev))
        }, 500)

        return () => clearInterval(interval)
    }, [])

    const faqs = isLoggedIn
        ? copywriting?.faqsLoggedIn || []
        : copywriting?.faqsLoggedOut || []

    return (
        <PbPropsProvider value={pbProps}>
            <section
                className={styles.faq}
                aria-labelledby="faq-title"
                data-testid={getTestId('mgm-faqv2')}>
                <div className={styles.faq__container}>
                    <h2 id="faq-title" className={styles.faq__title}>
                        {copywriting?.heading}
                    </h2>

                    {faqs.map((faqSection, sectionIndex) => (
                        <div key={sectionIndex} className={styles.faq__section}>
                            <div
                                className={
                                    styles.faq__section__title__container
                                }>
                                <h3 className={styles.faq__section__title}>
                                    {faqSection.heading}
                                </h3>
                            </div>

                            <div className={styles.faq__section__container}>
                                {faqSection.items?.map((item, itemIndex) => (
                                    <Collapse
                                        key={`${sectionIndex}-${itemIndex}`}
                                        className={styles.collapse}
                                        label={item.question}
                                        content={<p>{item.answer}</p>}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </PbPropsProvider>
    )
}

export default Faq
